<template>
  <div>
    <top-bar @reload="reloadEmpresa"/>
    <div class="content text-center" style="padding-top: 10vh" v-if="menu === 1">
      <loading v-if="load"/>
      <div v-else>
        <select-empresas @acessarEmpresa="acessarEmpresa" :salvar="true"/>
      </div>
    </div>
    <div v-else-if="src && key">
      <web-frame :src="src" :auth="key"/>
    </div>
  </div>
</template>

<script>
  import TopBar from '../../components/commons/TopBar.vue'
  import WebFrame from "@/views/gestor/WebFrame";
  import SelectEmpresas from "@/components/commons/SelectEmpresas";
  import Loading from "@/components/commons/Loading";

  export default {
    name: 'Cardapio',
    components: {Loading, SelectEmpresas, WebFrame, TopBar },

    data() {
      return {
        token: localStorage.getItem('key'),
        load: false,
        key: null,
        empresas: [],
        menu: 1,
        src: null,
        selEmpresa: { },
      }
    },

    methods: {
      reloadEmpresa(empresa) {
        this.menu = 1;
        this.load = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.load = false;
            this.acessarEmpresa(empresa)
          }, 1000);
        });
      },

      acessarEmpresa(empresa) {
        const key = empresa.key;
        const host = window.location.hostname;
        let src = "https://portal.lecard.app/";

        if (localStorage.getItem('base_server') === this.server_teste || host.startsWith('hhh')) {
          src = "https://hhh.portal.lecard.delivery/";

        } else if (host.startsWith('beta')) {
          src = "https://beta.portal.lecard.delivery/";

        } else if (host.startsWith('localhost')) {
          src = "https://hhh.portal.lecard.delivery/";
          //src = "http://localhost:8081/";
        }

        this.src = src + 'cardapio-frame';
        this.key = key;
        this.menu = 2;
      }
    },

    mounted() {
      // this.empresas = this.$store.state.empresas || [];
      // if (this.empresas.length === 1) {
      //   this.acessarEmpresa(this.empresas[0]);
      // }

      this.acessarEmpresa({ key: this.token });
    }
  }
</script>

<style scoped>
</style>
